import React, { useEffect } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import ReactGA from 'react-ga'
import { isMobile } from 'react-device-detect'
import routeView from './routeView'
import LeftMenu from './LeftBar'
import Participant from '../components/Participant/Participant.component';
import { routersHelper } from '../helpers'
import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import PopupStatus from '../helpers/PopupStatus'

const initializeReactGA = (page) => {
    ReactGA.initialize(window._env_.GoogleAnalyticsKey);
    ReactGA.pageview(page);
}
const Router = () => {
    const spinner = useSelector(state => state.backgroundRunning.spinner)
    const { useRouter } = routersHelper
    const router = useRouter()

    useEffect(() => {
        initializeReactGA(router.pathname)
    }, [router.pathname])

    return (
        <>
            <Spin spinning={spinner}>
                <PopupStatus />
                {!isMobile
                    ? <LeftMenu />
                    : <div />
                }
                <Switch>
                    <Route exact path="/" component={Participant} />
                    <Route exact path="/:name" component={Participant} />
                    <Route exact path="/lobbymanager" component={routeView} />
                    <Route exact path="/lobbymanager/:name" component={routeView} />
                    <Redirect to="/" />
                </Switch>
            </Spin>
        </>
    )
}

export default Router